import { ReparoApi } from './index';
import type { LoginPayloadResponse } from './consultantInvite';

export type VendorInvitePublicView = {
    email: string;
    firstName: string | null;
    lastName: string | null;
    /** The site's display name only - the id stays server-side on this public route. */
    siteName: string | null;
    expiresAt: string;
};

export type VendorInviteIssuedView = {
    inviteId: string;
    email: string;
    link: string;
    /** False when the mail did not go - the link is then the brand's to deliver by hand. */
    emailed: boolean;
    /** True when a pending invite for this address was refreshed and re-sent, not duplicated. */
    reused: boolean;
};

export const createVendorInvite = (payload: {
    email: string;
    warehouseId: string;
    firstName?: string;
    lastName?: string;
}): Promise<VendorInviteIssuedView> =>
    ReparoApi<VendorInviteIssuedView>({
        method: 'POST',
        url: '/vendor-invites',
        body: JSON.stringify(payload),
    });

export const getVendorInvite = (token: string): Promise<VendorInvitePublicView> =>
    ReparoApi<VendorInvitePublicView>({
        method: 'GET',
        url: `/vendor-invites/${encodeURIComponent(token)}`,
    });

export const acceptVendorInvite = (payload: {
    token: string;
    password: string;
    firstName?: string;
    lastName?: string;
}): Promise<LoginPayloadResponse> =>
    ReparoApi<LoginPayloadResponse>({
        method: 'POST',
        url: '/vendor-invites/accept',
        body: JSON.stringify(payload),
    });
